module.exports = __webpack_public_path__ + "img/extension_news_bg.e000982.webp";